export default {
    getEmployabilityNonValidatedDocumentsDataTableOptions: state => state.employabilityNonValidatedDocumentsDataTableOptions,
    getEmployabilityNonValidatedDocumentsRowActions: state => state.employabilityNonValidatedDocumentsRowActions,
    getEmployabilityNonValidatedDocumentsHeaderFields: state => state.employabilityNonValidatedDocumentsHeaderFields,
}
